import Vue from 'vue';

import ActionSheet from 'vant/lib/action-sheet';
import Dialog from 'vant/lib/dialog';
import Toast from 'vant/lib/toast';
import Search from 'vant/lib/search';
import Skeleton from 'vant/lib/skeleton';
import Field from 'vant/lib/field';
import Tab from 'vant/lib/tab';
import Tabs from 'vant/lib/tabs';
import { Tabbar, TabbarItem } from 'vant';
// Vue.use(List);

// import List from 'vant/lib/list';

import MarkdownItVue from 'markdown-it-vue';
import 'markdown-it-vue/dist/markdown-it-vue.css';

import markdownItKatex from 'markdown-it-katex';
import 'katex/dist/katex.min.css';

import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';

Vue.use(VueViewer);

Vue.use(ActionSheet);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Search);
Vue.use(Skeleton);
Vue.use(Field);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Tabbar);
Vue.use(TabbarItem);
// Vue.use(MarkdownItVue);

// 注册为全局组件
Vue.component('markdown-it-vue', MarkdownItVue);
Vue.component('markdown-it-katex', markdownItKatex);
